var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWorldIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 22c-4.976 0-9-4.023-9-9 0-4.976 4.024-9 9-9 4.977 0 9 4.024 9 9 0 4.977-4.023 9-9 9zm0-16.941c-4.341 0-7.941 3.6-7.941 7.941 0 4.341 3.6 7.941 7.941 7.941 4.341 0 7.941-3.6 7.941-7.941 0-4.341-3.6-7.941-7.941-7.941z",
    fill: "var(--color-secondary)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 21.47c-.317 0-.53-.211-.53-.529V5.06c0-.318.213-.53.53-.53.318 0 .53.212.53.53v15.988c0 .212-.212.424-.53.424z",
    fill: "var(--color-secondary)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.94 13.53H4.059c-.317 0-.529-.212-.529-.53 0-.318.212-.53.53-.53h15.988c.317 0 .53.212.53.53 0 .318-.319.53-.636.53z",
    fill: "var(--color-secondary)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.94 21.788C8.503 20.941 6.703 17.341 6.703 13c0-4.447 1.8-8.047 4.235-8.788l1.589.318c0 .317-.212.529-.53.529-2.33 0-4.235 3.6-4.235 7.941 0 4.341 1.906 7.941 4.235 7.941.318 0 .53.212.53.53l-1.589.317z",
    fill: "var(--color-secondary)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.47 21.47c0-.317.213-.53.53-.53 2.33 0 4.236-3.6 4.236-7.94 0-4.342-1.906-7.942-4.236-7.942-.317 0-.53-.211-.53-.529l1.377-.424c2.542.636 4.447 4.342 4.447 8.895 0 4.447-1.8 8.047-4.235 8.788l-1.588-.318z",
    fill: "var(--color-secondary)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorldIcon);
export default __webpack_public_path__ + "static/media/worldIcon.8ca522d0b15a8854e50297939f64c336.svg";
export { ForwardRef as ReactComponent };